import React from 'react';

interface DuplicateBannerProps {
  visible: boolean;
  onRefresh: () => void;
}

export function DuplicateBanner({ visible, onRefresh }: DuplicateBannerProps) {
  if (!visible) return null;
  return (
    <div
      className="flex items-center justify-between gap-3 mb-3"
      style={{
        background: 'var(--accent-bg)',
        border: '1px solid var(--accent)',
        borderRadius: 'var(--r-md)',
        padding: '10px 16px',
        fontSize: 'var(--fs-base)',
        color: 'var(--accent)',
      }}
    >
      <span>Orders have been updated by a team member</span>
      <button className="btn btn-primary btn-sm" onClick={onRefresh}>
        Refresh
      </button>
    </div>
  );
}
